import React from "react";
import { Link, RouteComponentProps } from "@reach/router";

const JobsPage: React.FC<RouteComponentProps> = () => (
  <div className="container legacy-bs-override">
    <h1>Careers at Haven Connect</h1>

    <div className="card">
      <h4>About Haven Connect</h4>
      <p style={{ fontSize: 15 }}>
        Haven Connect transforms the affordable housing industry by streamlining the application
        process for residents and property managers. Haven Connect uses automation and a deep
        understanding of the regulatory challenges for affordable housing to get low-income
        Americans into units faster {"&"} at a fraction of the cost.
      </p>

      <p style={{ fontSize: 15 }}>
        Haven Connect operates Nationwide and maintains offices in Austin & Denver.
      </p>

      <h4 style={{ marginTop: 20 }}>Product</h4>
      <li>
        <Link to="/careers/product-manager">Product Manager</Link>
      </li>
      <li>
        <Link to="/careers/product-designer">Product Designer</Link>
      </li>

      <h4 style={{ marginTop: 20 }}>Engineering</h4>
      <li>
        <Link to="/careers/full-stack-engineer">Full-stack Web Developer</Link>
      </li>
    </div>
  </div>
);

export default JobsPage;
